(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function init(root) {
    if (root.dataset.bannerCarouselReady === 'true') return;
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const total = slides.length;
    if (!total) return;
    root.dataset.bannerCarouselReady = 'true';

    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const status = root.querySelector('[data-status]');
    const progress = root.querySelector('[data-progress]');
    const toggle = root.querySelector('[data-toggle]');
    const ofLabel = root.dataset.ofLabel || '';
    const speed = (Number(root.dataset.speed) || 5) * 1000;
    const loop = root.dataset.loop === 'true';
    const pauseOnHover = root.dataset.pauseHover !== 'false';
    let index = slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
    if (index < 0) index = 0;
    let timer = 0;
    let hovered = false;
    let focused = false;
    let manuallyPaused = false;
    let editorPaused = false;
    let tracking = false;
    let startX = 0;
    let startY = 0;
    let suppressClick = false;

    function autoplayAllowed() {
      return root.dataset.autoplay === 'true' && total > 1 && !motionQuery.matches && !manuallyPaused && !hovered && !focused && !editorPaused && !document.hidden;
    }

    function announce() {
      if (!status) return;
      status.textContent = (index + 1) + ' ' + ofLabel + ' ' + total;
    }

    function syncMedia() {
      slides.forEach(function (slide, slideIndex) {
        const active = slideIndex === index;
        const skipVideo = slide.dataset.mobileImage === 'true' && mobileQuery.matches;
        const video = slide.querySelector('video');
        const frame = slide.querySelector('iframe');
        if (active && !skipVideo) {
          if (video) {
            const playAttempt = video.play();
            if (playAttempt && playAttempt.catch) playAttempt.catch(function () {});
          }
          if (frame && frame.dataset.src && frame.getAttribute('src') !== frame.dataset.src) {
            frame.setAttribute('src', frame.dataset.src);
          }
        } else {
          if (video) video.pause();
          if (frame && frame.getAttribute('src')) frame.removeAttribute('src');
        }
      });
    }

    function restartProgress() {
      if (!progress) return;
      progress.classList.remove('is-running');
      void progress.offsetWidth;
      if (autoplayAllowed()) progress.classList.add('is-running');
    }

    function stopTimer() {
      window.clearInterval(timer);
      timer = 0;
      if (progress) progress.classList.remove('is-running');
    }

    function startTimer() {
      stopTimer();
      if (!autoplayAllowed()) return;
      restartProgress();
      timer = window.setInterval(function () {
        go(index + 1, true);
      }, speed);
    }

    function syncControls(shouldAnnounce) {
      dots.forEach(function (dot, dotIndex) {
        const current = dotIndex === index;
        dot.classList.toggle('is-active', current);
        if (current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = !loop && index === 0;
      if (next) next.disabled = !loop && index === total - 1;
      slides.forEach(function (slide, slideIndex) {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      root.style.setProperty('--bc-index', String(index));
      syncMedia();
      restartProgress();
      if (shouldAnnounce) announce();
    }

    function go(nextIndex, fromTimer) {
      if (total < 2) return;
      if (!loop && (nextIndex < 0 || nextIndex >= total)) {
        if (fromTimer) stopTimer();
        return;
      }
      const target = loop ? (nextIndex + total) % total : Math.max(0, Math.min(total - 1, nextIndex));
      if (target === index) return;
      index = target;
      syncControls(true);
      startTimer();
    }

    function onPrev() { go(index - 1, false); }
    function onNext() { go(index + 1, false); }
    function onDotClick(event) {
      const dot = event.currentTarget;
      go(Number(dot.dataset.index), false);
    }
    function onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(index - 1, false);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(index + 1, false);
      }
    }
    function onPointerDown(event) {
      if (event.target.closest('a, button, input, textarea, iframe, video')) return;
      tracking = true;
      startX = event.clientX;
      startY = event.clientY;
    }
    function onPointerUp(event) {
      if (!tracking) return;
      tracking = false;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
      suppressClick = true;
      if (dx < 0) go(index + 1, false);
      else go(index - 1, false);
    }
    function onClick(event) {
      if (!suppressClick) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    }
    function onEnter() {
      hovered = true;
      stopTimer();
    }
    function onLeave() {
      hovered = false;
      startTimer();
    }
    function onFocusIn() {
      focused = true;
      stopTimer();
    }
    function onFocusOut(event) {
      if (root.contains(event.relatedTarget)) return;
      focused = false;
      startTimer();
    }
    function onToggle() {
      manuallyPaused = !manuallyPaused;
      toggle.setAttribute('aria-pressed', manuallyPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', manuallyPaused ? root.dataset.playLabel : root.dataset.pauseLabel);
      toggle.classList.toggle('is-paused', manuallyPaused);
      if (manuallyPaused) stopTimer();
      else startTimer();
    }
    function onVisibility() {
      if (document.hidden) stopTimer();
      else startTimer();
    }
    function onReduce() {
      if (motionQuery.matches) stopTimer();
      else startTimer();
    }
    function onBlockSelect(event) {
      const slide = event.target.closest('[data-slide]');
      if (!slide || !root.contains(slide)) return;
      editorPaused = true;
      stopTimer();
      const selected = Number(slide.dataset.index);
      if (selected === index) return;
      index = selected;
      syncControls(false);
    }
    function onBlockDeselect(event) {
      if (!root.contains(event.target)) return;
      editorPaused = false;
      startTimer();
    }

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    dots.forEach(function (dot) { dot.addEventListener('click', onDotClick); });
    root.addEventListener('keydown', onKeydown);
    root.addEventListener('pointerdown', onPointerDown);
    root.addEventListener('pointerup', onPointerUp);
    root.addEventListener('pointercancel', function () { tracking = false; });
    root.addEventListener('click', onClick, true);
    if (pauseOnHover) {
      root.addEventListener('mouseenter', onEnter);
      root.addEventListener('mouseleave', onLeave);
    }
    root.addEventListener('focusin', onFocusIn);
    root.addEventListener('focusout', onFocusOut);
    if (toggle) toggle.addEventListener('click', onToggle);
    document.addEventListener('visibilitychange', onVisibility);
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', onReduce);
    document.addEventListener('shopify:block:select', onBlockSelect);
    document.addEventListener('shopify:block:deselect', onBlockDeselect);

    syncControls(false);
    startTimer();

    root._bannerCarouselDestroy = function () {
      stopTimer();
      document.removeEventListener('visibilitychange', onVisibility);
      document.removeEventListener('shopify:block:select', onBlockSelect);
      document.removeEventListener('shopify:block:deselect', onBlockDeselect);
      if (motionQuery.removeEventListener) motionQuery.removeEventListener('change', onReduce);
      root.dataset.bannerCarouselReady = 'false';
    };
  }

  function boot(scope) {
    const context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-banner-carousel]').forEach(init);
  }

  function onSectionLoad(event) { boot(event.target); }
  function onSectionUnload(event) {
    const root = event.target.querySelector('[data-banner-carousel]');
    if (root && root._bannerCarouselDestroy) root._bannerCarouselDestroy();
  }

  boot(document);
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAwards(root) {
      if (!root || root.dataset.awardsReady === 'true') return;
      var track = root.querySelector('[data-awards-track]');
      var prev = root.querySelector('[data-awards-prev]');
      var next = root.querySelector('[data-awards-next]');
      var slider = root.querySelector('[data-awards-slider]');
      if (!track || !prev || !next || !slider) return;
      root.dataset.awardsReady = 'true';

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function cards() {
        return track.querySelectorAll('[data-awards-card]');
      }

      function stepSize() {
        var items = cards();
        if (items.length < 2) return track.clientWidth;
        var first = items[0].getBoundingClientRect().left;
        var second = items[1].getBoundingClientRect().left;
        var delta = second - first;
        if (delta < 1) delta = items[0].getBoundingClientRect().width;
        return delta;
      }

      function placeArrows() {
        var media = track.querySelector('.awards__media');
        if (!media) return;
        var sliderRect = slider.getBoundingClientRect();
        var mediaRect = media.getBoundingClientRect();
        var top = mediaRect.top - sliderRect.top + mediaRect.height / 2;
        slider.style.setProperty('--awards-arrow-top', top + 'px');
      }

      function updateArrows() {
        var max = track.scrollWidth - track.clientWidth;
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= max - 2;
        prev.hidden = atStart;
        next.hidden = atEnd || max <= 2;
        placeArrows();
      }

      function move(direction) {
        track.scrollBy({
          left: stepSize() * direction,
          behavior: reduce ? 'auto' : 'smooth'
        });
      }

      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          move(1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          move(-1);
        }
      });

      var observer = new ResizeObserver(updateArrows);
      observer.observe(track);
      root._awardsCleanup = function () { observer.disconnect(); };
      updateArrows();
      root.classList.add('awards--ready');
    }

    function boot(scope) {
      var context = scope || document;
      context.querySelectorAll('[data-awards]').forEach(initAwards);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-awards]');
      if (root && root._awardsCleanup) root._awardsCleanup();
    });

    document.addEventListener('shopify:block:select', function (event) {
      var card = event.target.closest('[data-awards-card]');
      if (!card) return;
      card.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
